import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from '@zurich/common/hooks';
import { libsUiDataNames } from '@zurich/test/testdatanames';
import { styled } from '../../utils';
import { FormFlex } from '../FormGrid';
import { IconButton } from '../IconButton';
import { Typography } from '../Typography';
export function FileInfo({ file, onDelete, disabled }) {
    const { t } = useTranslation();
    return (_jsxs(FormFlex, { justifyContent: "space-between", columnGap: 2, rowGap: 1, align: "flex-start", children: [_jsx(Typography, { variant: "body2", children: file.name }), _jsx(FileInfoIconStyled, { size: "small", variant: "bin", color: "error", onClick: () => onDelete(file), disabled: disabled, dataName: libsUiDataNames.cardEditable.buttonDelete, title: t('common:button_label.delete_file') })] }));
}
const FileInfoIconStyled = styled(IconButton)(({ theme }) => ({
    '& .MuiIcon-root.MuiIcon-fontSizeSmall': {
        fontSize: '0.875rem',
    },
    '&.MuiIconButton-sizeSmall': {
        padding: theme.spacing(0.25),
    },
}));
